if (!customElements.get("m-collection-reviews")) {
  class MCollectionReviews extends HTMLElement {
    constructor() {
      super();
      this.onNavClick = this.onNavClick.bind(this);
      this.updateNav = this.updateNav.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector(".m-collection-reviews__track");
      this.prev = this.querySelector(".m-collection-reviews__nav--prev");
      this.next = this.querySelector(".m-collection-reviews__nav--next");

      if (!this.track) return;

      this.navButtons = [this.prev, this.next].filter(Boolean);
      this.navButtons.forEach((btn) => btn.addEventListener("click", this.onNavClick));

      this.track.addEventListener("scroll", this.updateNav, { passive: true });
      window.addEventListener("resize", this.updateNav);

      // The track can change width after fonts/images settle, which changes
      // whether the arrows should be shown at all.
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.updateNav);
        this.resizeObserver.observe(this.track);
      }

      this.updateNav();
    }

    disconnectedCallback() {
      if (this.navButtons) {
        this.navButtons.forEach((btn) => btn.removeEventListener("click", this.onNavClick));
      }
      if (this.track) {
        this.track.removeEventListener("scroll", this.updateNav);
      }
      window.removeEventListener("resize", this.updateNav);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    // One card plus the flex gap, falling back to most of the visible width.
    step() {
      const card = this.track.querySelector(".m-collection-reviews__card");
      if (!card) return this.track.clientWidth * 0.8;

      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    onNavClick(event) {
      const button = event.currentTarget;
      const direction = parseInt(button.dataset.direction, 10) || 1;
      this.track.scrollBy({ left: this.step() * direction, behavior: "smooth" });
    }

    updateNav() {
      if (!this.track) return;

      const max = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= max - 2;
      const overflows = max > 2;

      if (this.prev) this.prev.disabled = !overflows || atStart;
      if (this.next) this.next.disabled = !overflows || atEnd;
    }
  }

  customElements.define("m-collection-reviews", MCollectionReviews);
}
